import { Extension } from '@tiptap/core';
import '@tiptap/extension-text-style';

// Tamanho de fonte para o TipTap 2 (nao existe extensao oficial).
// Segue o mesmo formato da @tiptap/extension-font-family e depende da extensao TextStyle carregada no editor.
const FontSize = Extension.create({
    name: 'fontSize',

    defaultOptions: {
        types: ['textStyle'],
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontSize: {
                        default: null,
                        renderHTML: attributes => {
                            if (!attributes.fontSize) {
                                return {};
                            }
                            return {
                                style: `font-size: ${attributes.fontSize}`,
                            };
                        },
                        parseHTML: element => ({
                            fontSize: element.style.fontSize || null,
                        }),
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setFontSize: fontSize => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { fontSize })
                    .run();
            },
            unsetFontSize: () => ({ chain }) => {
                return chain()
                    .setMark('textStyle', { fontSize: null })
                    .removeEmptyTextStyle()
                    .run();
            },
        };
    },
});

export default FontSize;
